<div class="fixed top-4 right-4 z-[9999] animate-[slideInUp_0.4s_ease] w-80 max-w-[calc(100vw-2rem)]">
  <div class="flex items-center gap-3 bg-gradient-to-r from-warning to-warning-dark text-white rounded-lg shadow-md p-3 border border-warning-dark/20 backdrop-blur-sm">
    <!-- Icon -->
    <div class="flex-shrink-0 w-8 h-8 bg-white/20 rounded-full flex items-center justify-center">
      <svg class="w-5 h-5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 9V13M12 17H12.01M10.29 3.86L1.82 18C1.64 18.32 1.54 18.68 1.53 19.05C1.52 19.42 1.6 19.79 1.77 20.12C1.94 20.45 2.19 20.73 2.49 20.94C2.79 21.15 3.14 21.28 3.5 21.32H20.5C20.86 21.28 21.21 21.15 21.51 20.94C21.81 20.73 22.06 20.45 22.23 20.12C22.4 19.79 22.48 19.42 22.47 19.05C22.46 18.68 22.36 18.32 22.18 18L13.71 3.86C13.52 3.55 13.26 3.29 12.95 3.11C12.64 2.93 12.29 2.83 11.93 2.83C11.57 2.83 11.22 2.93 10.91 3.11C10.6 3.29 10.34 3.55 10.15 3.86H10.29Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
    
    <!-- Message -->
    <div class="flex-1">
      <p class="text-xs font-normal leading-relaxed">{{ message() }}</p>
    </div>
    
    <!-- Close Button -->
    <button 
      (click)="closeToast()" 
      aria-label="Close notification"
      class="flex-shrink-0 w-7 h-7 bg-white/20 rounded-full flex items-center justify-center hover:bg-white/30 transition-colors"
    >
      <svg class="w-4 h-4" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15 5L5 15M5 5L15 15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
  </div>
</div>
